const prefix = '@LibertaLeads::'
const userData = `${prefix}userData`
const userSession = `${prefix}session`
const clientsCards = `${prefix}clientsCards`
const paramsLeads = `${prefix}paramsLeads`
// Só metadados da impersonação ({ admin: { id, nome }, expira_em }) — nunca um token.
const impersonation = `${prefix}impersonation`

export { userData, userSession, clientsCards, paramsLeads, impersonation }
